import { __assign, __rest } from 'tslib';
import { useTheme } from '../hooks/useTheme.js';
import 'react/jsx-runtime';
import 'react';
import '../Box/index.js';
import { useLayoutScreenContext } from '../LayoutScreen/LayoutScreen/LayoutScreenContext.js';
import '../LayoutScreen/LayoutHeader/LayoutHeader.js';
import { useMainNavContext } from './MainNavContext/index.js';

var useMainNavItem = function (_a) {
    var onClick = _a.onClick, exact = _a.exact, props = __rest(_a, ["onClick", "exact"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var sidebar = useLayoutScreenContext({ optional: true }).sidebar;
    var themeKey = useMainNavContext().themeKey;
    var forwardProps = handleStyleProps(props, { themeKey: "".concat(themeKey, "Item") });
    return __assign(__assign({ "data-nav-item": true, "data-disabled": !!props.disabled, onClick: sidebar
            ? function (event) {
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
                if (!event.defaultPrevented && !props.disabled) {
                    sidebar.setIsOpen(false);
                }
            }
            : onClick }, (exact ? { exact: exact } : null)), forwardProps);
};

export { useMainNavItem };
//# sourceMappingURL=useMainNavItem.js.map
